export default __webpack_public_path__ + "images/2e6a80683512d43df468c995bc7b2141-americana_music.jpg";